(function($){
  'use strict';

  function Price(){
    var self = this,
        $el = null,

        amountSlider = null,
        amountMin = null,
        amountMax = null,
        amountMinValue = 0,
        amountMaxValue = 0,
        amountMaxGap = 10000000,
        priceMin = null,
        priceMax = null,

        options = {};

    function initSlider() {
      amountSlider = document.getElementById('price-slider');
      amountMin = document.querySelector('.js-amount-min');
      amountMax = document.querySelector('.js-amount-max');
      priceMin = document.querySelector('.b-filters__price__min');
      priceMax = document.querySelector('.b-filters__price__max');

      amountMinValue = parseInt(amountSlider.getAttribute('data-min'));
      amountMaxValue = parseInt(amountSlider.getAttribute('data-max'));

      // Display format
      var format = {
        decimals: 0,
        thousand: ' ',
        postfix: ' $'
      };

      // Init
      noUiSlider.create(amountSlider, {
        start: [ parseInt(amountSlider.getAttribute('data-start-min')), parseInt(amountSlider.getAttribute('data-start-max')) ],
        connect: true,
        step: 1000,
        range: {
          'min': amountMinValue,
          'max': amountMaxValue,
        },
        //tooltips: [ wNumb(format), wNumb(format) ],
        format: wNumb({
          decimals: 0,
        })
      });

      // Update hidden input to send form
      var $maxTooltip = $('.noUi-origin').last().find('.noUi-tooltip');
      amountSlider.noUiSlider.on('update', function(values, handle) {
        var value = values[handle];

        if (handle === 0) {
            priceMin.innerHTML = value;
            amountMin.value = value;
        } else {
            priceMax.innerHTML = value;
            amountMax.value = value;
        }
      });
    }

    /**
     * Public constructeur
     * @param opts
     */
    self.initialize = function(opts) {
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $el = options.$el;

      initSlider();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  window.Price = Price;

}(jQuery));
